import PageBackTitle from "../../Component/PageBackTitle";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Tooltip from "@mui/material/Tooltip";
import { HiOutlinePlus } from "react-icons/hi";
import { IoSearchOutline } from "react-icons/io5";
import { TbRefresh } from "react-icons/tb";
import Pagination from "../../Component/Pagination";
import { hrRecordsApi } from "../../Services/hrRecordsApi";
import {
  truthyLabel,
} from "../hrRecordsHelpers";
import "../hrRecords.css";
import "../../tables/User.css";

function TrainingMastersListPage({ isSidebarExpanded }) {
  const navigate = useNavigate();
  const [masters, setMasters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [totalItems, setTotalItems] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const showSnackbar = (message, severity = "success") => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const fetchMasters = async (
    currentPage = page,
    currentItemsPerPage = itemsPerPage,
  ) => {
    try {
      setLoading(true);
      const response = await hrRecordsApi.listTrainingMasters({
        page: currentPage,
        per_page: currentItemsPerPage,
        search: searchInput || undefined,
      });
      setMasters(response.items || []);
      setTotalItems(response.total_items || 0);
    } catch (error) {
      console.error("Failed to load training masters:", error);
      showSnackbar("Failed to load training masters", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timer = window.setTimeout(() => {
      fetchMasters(page, itemsPerPage);
    }, 350);

    return () => window.clearTimeout(timer);
  }, [page, itemsPerPage, searchInput]);

  const handleDelete = async (masterId) => {
    if (!window.confirm("Delete this training master?")) {
      return;
    }

    try {
      await hrRecordsApi.deleteTrainingMaster(masterId);
      showSnackbar("Training master deleted successfully");
      fetchMasters(page, itemsPerPage);
    } catch (error) {
      console.error("Failed to delete training master:", error);
      showSnackbar(
        error?.response?.data?.message || "Failed to delete training master",
        "error",
      );
    }
  };

  return (
    <>
      <div
        className={`data-list-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-list-content">
          <div className="data-list-header">
            <div className="data-list-header-content">
              <PageBackTitle>Training Catalogues</PageBackTitle>
              <div className="data-list-heading-content-right-side hr-records-toolbar">
                <div className="search-bar-container">
                  <input
                    className="search-bar"
                    placeholder="Search training masters..."
                    value={searchInput}
                    onChange={(event) => {
                      setSearchInput(event.target.value);
                      setPage(1);
                    }}
                  />
                  <IoSearchOutline className="search-bar-icon" />
                </div>
                <Tooltip title="Add New Training" arrow>
                  <button
                    className="new-button"
                    onClick={() => navigate("/add-hr-training-master")}
                  >
                    <HiOutlinePlus className="new-plus-icon" /> New
                  </button>
                </Tooltip>
                <Tooltip title="Refresh" arrow>
                  <button
                    className="refresh-button"
                    onClick={() => {
                      setSearchInput("");
                      setPage(1);
                      fetchMasters(1, itemsPerPage);
                    }}
                  >
                    <TbRefresh className="refresh-icon" />
                  </button>
                </Tooltip>
              </div>
            </div>
          </div>

          <div className="header-separator"></div>
          <div className="data-list-body">
            <div className="data-list-scroll-body">
              <div className="data-list-table">
                {loading ? (
                  <div className="loader-container">
                    <div className="loader"></div>
                    <div>Loading...</div>
                  </div>
                ) : masters.length > 0 ? (
                  <table className="table multilevel-data">
                    <thead>
                      <tr>
                        <th>SR. NO.</th>
                        <th>TRAINING</th>
                        <th>STANDARD</th>
                        <th>REPEAT POLICY</th>
                        <th>MANDATORY</th>
                        <th>ACTIVE</th>
                        <th>SESSIONS</th>
                        <th>PARTICIPANTS</th>
                        <th>CREATED AT</th>
                        <th>ACTION</th>
                      </tr>
                    </thead>
                    <tbody className="data-list-scroll-bodys">
                      {masters.map((master, index) => (
                        <tr key={master.id} className="hoverable-row">
                          <td>{(page - 1) * itemsPerPage + index + 1}</td>
                          <td>
                            {master.training_name || "NA"}
                            <br />
                            <span style={{ color: "#68768a", fontSize: "12px" }}>
                              {master.training_category || "No category"}
                            </span>
                          </td>
                          <td>
                            {master.standard_body || "NA"}
                            <br />
                            <span style={{ color: "#68768a", fontSize: "12px" }}>
                              {master.standard_ref_no || "No ref"}
                            </span>
                          </td>
                          <td>
                            {master.repeat_every
                              ? `${master.repeat_every} ${master.repeat_unit || ""}`
                              : "NA"}
                          </td>
                          <td>{truthyLabel(master.is_mandatory)}</td>
                          <td>{truthyLabel(master.is_active)}</td>
                          <td>{master.session_count || 0}</td>
                          <td>{master.participant_count || 0}</td>
                          <td>
                            {master.created_at
                              ? new Date(master.created_at)
                                  .toUTCString()
                                  .split("GMT")[0]
                                  .trim() + " IST"
                              : "NA"}
                          </td>
                          <td className="center-alignment">
                            <div className="hr-records-inline-actions">
                              <button
                                className="button-bg"
                                onClick={() =>
                                  navigate(`/hr-training-master-view/${master.id}`)
                                }
                              >
                                View
                              </button>
                              <Link to={`/edit-hr-training-master/${master.id}`}>
                                <button className="button-bg">Edit</button>
                              </Link>
                              {/* <button
                                className="button-bg"
                                onClick={() => handleDelete(master.id)}
                              >
                                Delete
                              </button> */}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="no-users-container">
                    <div className="no-users-message">No training masters found</div>
                  </div>
                )}
              </div>

              <Pagination
                key={searchInput}
                showPerPage={itemsPerPage}
                total={totalItems}
                onPaginationChange={(currentPage, perPage) => {
                  setPage(currentPage);
                  setItemsPerPage(perPage);
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert severity={snackbarSeverity}>{snackbarMessage}</MuiAlert>
      </Snackbar>
    </>
  );
}

export default TrainingMastersListPage;
